/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { StirBatchBase } from "../../../../schema/generated/StirBatch";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class StirBatchDataApi extends EntityDataApi<StirBatchBase> {
  public readonly def = idbEntityDefs.StirBatch;
}